import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import {
  MerchantPackageRightApplicationModel,
  MerchantPackageRightModel,
  MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel,
  MerchantPackageRightPeakAccountApplicationAccountsModel,
  MerchantPackageRightPeakAccountApplicationDocumentSettingModel,
  MerchantPackageRightPeakAccountApplicationExpenseModel,
  MerchantPackageRightPeakAccountApplicationFinanceModel,
  MerchantPackageRightPeakAccountApplicationModel,
  MerchantPackageRightPeakAccountApplicationRevenueModel,
  MerchantPackageRightPeakAccountApplicationSettingModel,
  MerchantPackageRightPeakAccountApplicationUserSettingModel,
  MerchantPackageRightPeakAssetApplicationModel,
  MerchantPackageRightPeakPayrollApplicationModel,
  MerchantPackageRightPeakTaxApplicationModel,
  SelectedMerchantModel,
  UserRoleInfoModel,
} from "@/model/merchant/selectedMerchantModel";

function GetMerchantPackageRightApplication(applicationRaw: any): MerchantPackageRightApplicationModel {
  return {
    peakAccount: applicationRaw.peakAccount,
    oldPeakAccount: applicationRaw.oldPeakAccount,
    peakPayroll: applicationRaw.peakPayroll,
    peakAsset: applicationRaw.peakAsset,
    peakBoard: applicationRaw.peakBoard,
    peakTax: applicationRaw.peakTax,
    peakLineConnect: applicationRaw.peakLineConnect,
    peakMobile: applicationRaw.peakMobile,
    peakDocument: applicationRaw.peakDocument,
  };
}
function GetMerchantPackageRightPeakAccountApplicationRevenue(
  revenueRaw: any
): MerchantPackageRightPeakAccountApplicationRevenueModel {
  return {
    quotation: revenueRaw.quotation,
    invoice: revenueRaw.invoice,
    invoiceAsset: revenueRaw.invoiceAsset,
    receipt: revenueRaw.receipt,
    receiptAsset: revenueRaw.receiptAsset,
    taxInvoice: revenueRaw.taxInvoice,
    creditNote: revenueRaw.creditNote,
    billingNote: revenueRaw.billingNote,
    debitNote: revenueRaw.debitNote,
    recurringInvoice: revenueRaw.recurringInvoice,
    recurringReceipt: revenueRaw.recurringReceipt,
  };
}
function GetMerchantPackageRightPeakAccountApplicationExpense(
  expenseRaw: any
): MerchantPackageRightPeakAccountApplicationExpenseModel {
  return {
    purchaseOrder: expenseRaw.purchaseOrder,
    purchaseOrderAsset: expenseRaw.purchaseOrderAsset,
    expense: expenseRaw.expense,
    purchaseAsset: expenseRaw.purchaseAsset,
    purchaseTaxInvoice: expenseRaw.purchaseTaxInvoice,
    receivedCreditNote: expenseRaw.receivedCreditNote,
    receivedDebitNote: expenseRaw.receivedDebitNote,
    combinePaymentNote: expenseRaw.combinePaymentNote,
    recurringExpense: expenseRaw.recurringExpense,
  };
}
function GetMerchantPackageRightPeakAccountApplicationFinance(
  financeRaw: any
): MerchantPackageRightPeakAccountApplicationFinanceModel {
  return {
    addFinance: financeRaw.addFinance,
    reconcile: financeRaw.reconcile,
    statement: financeRaw.statement,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccounts(
  accountRaw: any
): MerchantPackageRightPeakAccountApplicationAccountsModel {
  return {
    addAccount: accountRaw.addAccount,
    actionJournal: accountRaw.actionJournal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationDocumentSetting(
  documentRaw: any
): MerchantPackageRightPeakAccountApplicationDocumentSettingModel {
  return {
    cassification: documentRaw.cassification,
    redirectLinkReport: documentRaw.redirectLinkReport,
    taxInvoice: documentRaw.taxInvoice,
    journal: documentRaw.journal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationUserSetting(
  userRaw: any
): MerchantPackageRightPeakAccountApplicationUserSettingModel {
  return {
    userRoleContact: userRaw.userRoleContact,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(
  accountingPolicyRaw: any
): MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel {
  return {
    summaryReport: accountingPolicyRaw.summaryReport,
    creditLimit: accountingPolicyRaw.creditLimit,
    purchaseOrderStatusUpdate: accountingPolicyRaw.purchaseOrderStatusUpdate,
  };
}
function GetMerchantPackageRightPeakAccountApplicationSetting(
  settingRaw: any
): MerchantPackageRightPeakAccountApplicationSettingModel {
  return {
    user: GetMerchantPackageRightPeakAccountApplicationUserSetting(settingRaw.user),
    document: GetMerchantPackageRightPeakAccountApplicationDocumentSetting(settingRaw.document),
    accountingPolicy: GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(settingRaw.accountingPolicy),
    applicationConnect: settingRaw.applicationConnect,
  };
}
function GetMerchantPackageRightPeakAccountApplication(
  accountRaw: any
): MerchantPackageRightPeakAccountApplicationModel {
  return {
    totalDocumentPerMonth: accountRaw.totalDocumentPerMonth,
    export: accountRaw.export,
    importProduct: accountRaw.importProduct,
    importContact: accountRaw.importContact,
    importTransaction: accountRaw.importTransaction,
    partailPayment: accountRaw.partailPayment,
    revenue: GetMerchantPackageRightPeakAccountApplicationRevenue(accountRaw.revenue),
    expense: GetMerchantPackageRightPeakAccountApplicationExpense(accountRaw.expense),
    finance: GetMerchantPackageRightPeakAccountApplicationFinance(accountRaw.finance),
    account: GetMerchantPackageRightPeakAccountApplicationAccounts(accountRaw.account),
    fileVault: accountRaw.fileVault,
    setting: GetMerchantPackageRightPeakAccountApplicationSetting(accountRaw.setting),
  };
}
function GetMerchantPackageRightPeakTaxApplication(taxRaw: any): MerchantPackageRightPeakTaxApplicationModel {
  return { fetchDataFromPeakAccount: taxRaw.fetchDataFromPeakAccount };
}
function GetMerchantPackageRightPeakAssetApplication(assetRaw: any): MerchantPackageRightPeakAssetApplicationModel {
  return { totalAsset: assetRaw.totalAsset };
}
function MerchantPackageRightPeakPayrollApplication(payrollRaw: any): MerchantPackageRightPeakPayrollApplicationModel {
  return { totalEmployee: payrollRaw.totalEmployee };
}
function GetMerchantPackageRight(merchantPackageRightRaw: any): MerchantPackageRightModel {
  return {
    application: merchantPackageRightRaw
      ? GetMerchantPackageRightApplication(merchantPackageRightRaw.application)
      : new MerchantPackageRightApplicationModel(),
    account: merchantPackageRightRaw
      ? GetMerchantPackageRightPeakAccountApplication(merchantPackageRightRaw.account)
      : new MerchantPackageRightPeakAccountApplicationModel(),
    tax: merchantPackageRightRaw
      ? GetMerchantPackageRightPeakTaxApplication(merchantPackageRightRaw.tax)
      : new MerchantPackageRightPeakTaxApplicationModel(),
    asset: merchantPackageRightRaw
      ? GetMerchantPackageRightPeakAssetApplication(merchantPackageRightRaw.asset)
      : new MerchantPackageRightPeakAssetApplicationModel(),
    payroll: merchantPackageRightRaw
      ? MerchantPackageRightPeakPayrollApplication(merchantPackageRightRaw.payroll)
      : new MerchantPackageRightPeakPayrollApplicationModel(),
  };
}
function GetRole(userRoleRaw: any): UserRoleInfoModel {
  return {
    authorityRole: userRoleRaw?.authorityRole ?? 0,
    role: userRoleRaw?.role ?? 0,
    manageUser: userRoleRaw?.manageUser ?? 0,
    manageFinance: userRoleRaw?.manageFinance ?? 0,
    isSuperUser: userRoleRaw?.isSuperUser ?? 0,
    isUsePayroll: userRoleRaw?.isUsePayroll ?? 0,
    isUsePeakBoard: userRoleRaw?.isUsePeakBoard ?? 0,
    manageProduct: userRoleRaw?.manageProduct ?? 0,
    isSeeSelfDocuments: userRoleRaw?.isSeeSelfDocuments ?? 0,
    manageFinanceAndJournals: userRoleRaw?.manageFinanceAndJournals ?? 0,
    manageAsset: userRoleRaw?.manageAsset ?? 0,
    manageContact: userRoleRaw?.manageContact ?? 0,
    isViewReport: userRoleRaw?.isViewReport ?? 0,
  };
}
export function GetSelectedMerchant(merchantRaw: any): SelectedMerchantModel {
  return {
    merchantId: merchantRaw.merchantId,
    merchantName: merchantRaw.merchantName,
    merchantNameEng: merchantRaw.merchantNameEng,
    merchantNameTh: merchantRaw.merchantNameTh,
    merchantBranchCode: merchantRaw.merchantBranchCode,
    merchantTaxId: merchantRaw.merchantTaxId,
    code: merchantRaw.code,
    createDateTime: merchantRaw.createDateTime,
    isAccountingFirm: merchantRaw.isAccountingFirm,
    merchantType: merchantRaw.merchantType,
    taxStatus: merchantRaw.taxStatus,
    logoUrl: merchantRaw.logoUrl,
    stampUrl: merchantRaw.stampUrl,
    isSample: merchantRaw.isSample,
    isVat: merchantRaw.isVat,
    isActivePayroll: merchantRaw.isActivePayroll,
    isLockPeriod: merchantRaw.isLockPeriod,
    lockPeriodEndDate: merchantRaw.lockPeriodEndDate,
    joinMerchantDateTime: merchantRaw.joinMerchantDateTime,
    package: merchantRaw.package,
    expireDateTime: merchantRaw.expireDateTime,
    packageName: merchantRaw.packageName,
    merchantPackageRight: GetMerchantPackageRight(merchantRaw.merchantPackageRight),
    role: GetRole(merchantRaw.role),
    roleApplication: merchantRaw.roleApplication,
    applicationPermission: merchantRaw.applicationPermission,
    isActiveOldPEAK: merchantRaw.isActiveOldPEAK,
  };
}

export function ConvertToMerchantList(merchantListRaw: any): Array<MerchantInFoModel> {
  const merchantList: Array<MerchantInFoModel> = [];
  if (merchantListRaw && merchantListRaw.length > 0) {
    for (const merchantRaw of merchantListRaw) {
      merchantList.push({
        merchantId: merchantRaw.merchantId,
        merchantName: merchantRaw.merchantName,
        merchantNameEng: merchantRaw.merchantNameEng,
        merchantNameTh: merchantRaw.merchantNameTh,
        merchantBranchCode: merchantRaw.merchantBranchCode,
        isSample: merchantRaw.isSample,
        merchantTaxId: merchantRaw.merchantTaxId,
      });
    }
  }
  return merchantList;
}

export function CompareMerchantNameTh(a: MerchantInFoModel, b: MerchantInFoModel) {
  if (a.merchantNameTh < b.merchantNameTh) {
    return -1;
  } else if (a.merchantNameTh > b.merchantNameTh) {
    return 1;
  } else {
    return 0;
  }
}

export function CompareMerchantNameEn(a: MerchantInFoModel, b: MerchantInFoModel) {
  if (a.merchantNameEng < b.merchantNameEng) {
    return -1;
  } else if (a.merchantNameEng > b.merchantNameEng) {
    return 1;
  } else {
    return 0;
  }
}

export function SetMerchantForDisplay(merchant: MerchantInFoModel) {
  return {
    isSample: merchant.isSample,
    merchantBranchCode: merchant.merchantBranchCode,
    merchantId: merchant.merchantId,
    merchantName: merchant.merchantName,
    merchantNameEng: merchant.merchantNameEng,
    merchantNameTh: merchant.merchantNameTh,
  };
}
